import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'TechCore',
  brandName: 'TechCore',
  description: 'Sistema de agendamento para suporte técnico de TI',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Técnico de informática trabalhando',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Suporte técnico em casa',
  },
  testimonials: [
    {
      name: 'David Antunes',
      role: 'Técnico de IT',
      text: 'Com o TechCore, a gestão das visitas aos clientes ficou muito mais simples e organizada.',
      image: testimonial1,
    },
    {
      name: 'Sra. Elvira',
      role: 'Cliente',
      text: 'Agendei a visita do técnico para resolver o problema do meu computador e foi tudo muito rápido e profissional.',
      image: testimonial2,
    },
    {
      name: 'PC-Solutions',
      role: 'Empresa de Suporte',
      text: 'Este sistema permite-nos gerir a nossa equipa de técnicos no terreno de forma muito eficaz.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'técnico de TI',
    professionals: 'técnicos de TI',
    business: 'empresa',
    businesses: 'empresas',
    service: 'suporte',
    services: 'suportes',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'visita',
    appointments: 'visitas',
  },
  homepage: {
    hero: {
      badge: 'Suporte Técnico',
      title: 'Resolva problemas técnicos com TechCore',
      description: 'Organize suas visitas domiciliárias e ofereça suporte técnico eficiente com o TechCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '220+', label: 'Técnicos de TI' },
      { value: '18k+', label: 'Suportes Realizados' },
      { value: '94%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Deslocações Ineficientes',
        description: 'Técnicos perdem tempo em deslocações mal planeadas entre casas de clientes.',
        icon: 'MapPin',
        quote: {
          text: 'Antes do TechCore perdia 3 horas diárias em trânsito por má organização das rotas',
          author: 'João Silva',
          business: 'TechHelp Solutions',
        },
      },
      {
        title: 'Diagnóstico Remoto Limitado',
        description: 'Sem informações prévias do problema, é difícil levar as peças e ferramentas certas.',
        icon: 'Wrench',
        stats: [
          { label: 'Visitas com falta de peças:', value: '35%' },
          { label: 'Tempo perdido em regressos:', value: '12h/semana' },
        ],
      },
      {
        title: 'Emergências Não Planeadas',
        description: 'Chamadas de emergência desorganizam a agenda e afetam outros clientes.',
        icon: 'AlertCircle',
        quote: {
          text: 'Com o sistema de prioridades consigo gerir emergências sem prejudicar outros clientes',
          author: 'Pedro Costa',
          business: 'HomeIT Services',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'TechCore: O seu assistente técnico',
      description: 'Tecnologia para técnicos que valorizam eficiência e satisfação do cliente.',
      features: [
        {
          title: 'Otimização de Rotas',
          description: 'Organize automaticamente visitas por proximidade geográfica para reduzir deslocações.',
        },
        {
          title: 'Pré-Diagnóstico',
          description: 'Clientes descrevem problemas antecipadamente para você levar exatamente o que precisa.',
        },
        {
          title: 'Gestão de Urgências',
          description: 'Sistema de prioridades que permite inserir emergências sem desorganizar toda a agenda.',
        },
      ],
    },
    testimonials: {
      title: 'O que os técnicos de TI dizem',
      description: 'Técnicos que otimizaram sua produtividade com o TechCore.',
    },
    finalCta: {
      title: 'Pronto para otimizar seu suporte técnico?',
      description: 'Junte-se aos técnicos que já aumentaram sua eficiência com o TechCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de técnico de TI',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
